import React from "react";
import Drawer from "@mui/material/Drawer";
import { useTranslation } from "react-i18next";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "../../Hooks";
import useStyles from "./FmRightDrawer.style";

interface FmRightDrawerProps {
    title: string;
    children: React.ReactNode;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    isEditMode: boolean;
}

const FmRightDrawer = ({ title, children, isOpen, setIsOpen, isEditMode = false }: FmRightDrawerProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const { t } = useTranslation();

    const isRtl = theme.direction === "rtl";

    return (
        <div className={classes.drawersWrapper_container}>
            {/* // -------------------------- Main Drawer -------------------------// */}
            <div className={classes.mainDrawer_wrapper}>
                <Drawer
                    className={isEditMode ? classes.editMode_drawer_container : classes.drawer_container}
                    variant='persistent'
                    anchor={"right"}
                    open={isOpen}
                >
                    <div className={classes.main_drawer_container}>
                        <div className={classes.header}>
                            <span className={classes.title_text}>{title}</span>
                            <div>
                                <IconButton onClick={() => setIsOpen(false)}>
                                    {theme.direction === "rtl" ? <ChevronLeftIcon sx={{ fontSize: "36px" }} /> : <ChevronRightIcon sx={{ fontSize: "36px" }} />}
                                </IconButton>
                            </div>
                        </div>
                        <div className={classes.scrollable_content_container}>
                            <div className={classes.contentContainer}>{children}</div>
                        </div>
                    </div>
                </Drawer>
            </div>

            {/* // -------------------------- Small Drawer -------------------------// */}
            <div className={classes.smallDrawer_wrapper}>
                <Drawer
                    className={isEditMode ? classes.editMode_small_drawer_container_sx : classes.small_drawer_container_sx}
                    variant='persistent'
                    anchor={"right"}
                    open={!isOpen}
                >
                    <div className={classes.small_drawer_container}>
                        <IconButton onClick={() => setIsOpen(true)}>
                            {isRtl ? <ChevronRightIcon sx={{ fontSize: "30px" }} /> : <ChevronLeftIcon sx={{ fontSize: "30px" }} />}
                        </IconButton>
                        <div className={classes.small_drawer_title_container}>
                            <span>{t("rightDrawer.showMoreText")}</span>
                            <span>{title}</span>
                        </div>
                    </div>
                </Drawer>
            </div>
        </div>
    );
};

export default FmRightDrawer;
